<script lang="ts">
import CreateTicketFromPlantJsonButton from '@/presentation/components/tickets/CreateTicketFromPlantJsonButton.vue';

export default {
  name: 'CreateTicketColumn',
  components: { CreateTicketFromPlantJsonButton },
  props: {
    companyId: { required: true, type: Number },
  },
  emits: ['ticket-created'],
};
</script>

<template>
  <Column field="plant.create_ticket" header="Create ticket">
    <template #body="slotProps">
      <create-ticket-from-plant-json-button
        v-if="slotProps.data.plant.owning_company_id === companyId"
        type="text"
        :plant-json="slotProps.data.plant"
        :company-id="companyId"
        @ticket-created="$emit('ticket-created', $event)"
      />
    </template>
  </Column>
</template>

<style scoped></style>
